module.exports = __webpack_public_path__ + "static/media/roadtrip.ec03a8b3.gif";